import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from "axios";
import { Thunk } from "../../store";
import {
  BackendListaTareasTomadasPorUsuario,
  getCurrentDomain,
} from "../../../apis/backend/Api";
import mock_Json from "../../../dataJson/ObtenerTareasTomadasUsuario.json";
import {
  formatearMensajeBackend,
  procesarDosPropiedadMapeo,
  procesarPrioridades,
} from "../../../apis/helper/helperApi";
import { formatearFechaCustom } from "../../../components/common/helper/formatoFecha";
import { TypeStatus } from "../../helpers/constantes";

interface State {
  listaTareasTomadasPorUsuario: any[];
  status: TypeStatus;
  isLoading: boolean;
  Success: boolean;
  Mensaje: string | null;
  error: string | null;
}

const initialState: State = {
  listaTareasTomadasPorUsuario: [],
  status: "idle",
  isLoading: false,
  Success: false,
  Mensaje: "",
  error: null,
};
interface defaultResponse {
  data: any;
  status: number;
  statusText: string;
  headers: AxiosResponseHeaders | {};
  config: any;
  request?: any;
}
const defaultResp: defaultResponse = {
  data: undefined,
  status: 0,
  statusText: "",
  headers: {},
  config: undefined,
};
const listaTareasTomadasPorUsuarioSlice = createSlice({
  name: "listaTareasTomadasPorUsuario",
  initialState,
  reducers: {
    setListaTareasTomadasPorUsuario: (state, action: PayloadAction<any[]>) => {
      state.listaTareasTomadasPorUsuario = action.payload;
    },
    getListaTareasTomadasPorUsuario: (state, action: PayloadAction<any[]>) => {
      state.listaTareasTomadasPorUsuario = action.payload;
    },
    setClearListaTareasTomadasPorUsuario: (
      state,
      action: PayloadAction<any[]>,
    ) => {
      state = initialState;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setStatus: (state, action: PayloadAction<TypeStatus>) => {
      state.status = action.payload;
    },
    setResult: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.Success = action.payload;
    },
    setMensaje: (state, action: PayloadAction<string>) => {
      state.Mensaje = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});
export const setBackendListaTareasTomadasPorUsuario =
  (caseId: number): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));

    try {
      const response: AxiosResponse =
        await BackendListaTareasTomadasPorUsuario(caseId);

      const isError =
        response.data?.Success === false ||
        (response.data?.ResultadoSolicitud !== undefined &&
          response.data?.ResultadoSolicitud !== 200);

      if (isError) {
        dispatch(setIsLoading(false));
        dispatch(setStatus("failed"));
        dispatch(setSuccess(false));
      } else {
        let ordenarLista = [...(response.data.Data || [])];
        ordenarLista = procesarPrioridades(ordenarLista);
        ordenarLista = procesarDosPropiedadMapeo(
          ordenarLista,
          "last_update_date",
          "UltimaActualizacion",
        );
        ordenarLista = procesarDosPropiedadMapeo(ordenarLista, "id", "Tarea");
        ordenarLista = procesarDosPropiedadMapeo(
          ordenarLista,
          "FechaHoraInicio",
          "FechaAlta",
        );
        let updatelistaFormateada = ordenarLista.map((e: any) => ({
          ...e,
          FechaHoraInicio: formatearFechaCustom(e.FechaHoraInicio),
          UltimaActualizacion: formatearFechaCustom(e.UltimaActualizacion),
          FechaAlta: formatearFechaCustom(e.FechaAlta),
          assigned_date: formatearFechaCustom(e.assigned_date),
          reached_state_date: formatearFechaCustom(e.reached_state_date),
          last_update_date: formatearFechaCustom(e.last_update_date),
          dueDate: formatearFechaCustom(e.dueDate),
        }));

        dispatch(setListaTareasTomadasPorUsuario(updatelistaFormateada));
        dispatch(setIsLoading(false));
        dispatch(setStatus("succeeded"));
        dispatch(setSuccess(true));
      }
      dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setSuccess(false));
      dispatch(setStatus("failed"));

      if (error.response?.status === 401) {
        dispatch(setStatus("noAutorice"));
        dispatch(
          setMensaje(
            formatearMensajeBackend(
              "Tu sesión ha expirado. Vuelve a iniciar sesión",
            ),
          ),
        );
      } else if (error.response) {
        // Hay respuesta del servidor, pero es otro error (400, 422, 500, etc.)
        console.error(
          "Error de servidor:",
          error.response.status,
          error.response.data,
        );

        const errorData = error.response.data;
        const mensajeBackend = errorData?.Mensaje;
        const resultadoSolicitud = errorData?.ResultadoSolicitud;

        if (
          mensajeBackend &&
          (resultadoSolicitud !== 200 || errorData?.Success === false)
        ) {
          dispatch(setMensaje(formatearMensajeBackend(mensajeBackend)));
        } else {
          dispatch(
            setMensaje(
              `Error ${error.response.status}: Ocurrió un problema en el servidor.`,
            ),
          );
        }
      } else if (error.request) {
        console.error("Error de conexión:", error.message);
        dispatch(
          setMensaje(
            "No se pudo conectar al servidor. Por favor, revisa tu conexión a internet o tu VPN.",
          ),
        );
      } else {
        console.error("Error de red o solicitud:", error.message);
        dispatch(
          setMensaje(
            "Ocurrió un problema con la red. Por favor, verifica tu conexión.",
          ),
        );
      }
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
      if (getCurrentDomain() === "localhost") {
        dispatch(setIsLoading(true));
        let response: AxiosResponse = defaultResp;
        response.data = mock_Json;

        const mockData: any = mock_Json;
        const isErrorMock =
          mockData?.Success === false ||
          (mockData?.ResultadoSolicitud !== undefined &&
            mockData?.ResultadoSolicitud !== 200);

        if (isErrorMock) {
          dispatch(setIsLoading(false));
          dispatch(setStatus("failed"));
          dispatch(setSuccess(false));
        } else {
          let ordenarLista = [...(mock_Json.Data || [])];
          ordenarLista = procesarPrioridades(ordenarLista);
          ordenarLista = procesarDosPropiedadMapeo(
            ordenarLista,
            "last_update_date",
            "UltimaActualizacion",
          );
          ordenarLista = procesarDosPropiedadMapeo(ordenarLista, "id", "Tarea");
          ordenarLista = procesarDosPropiedadMapeo(
            ordenarLista,
            "FechaHoraInicio",
            "FechaAlta",
          );
          let updatelistaFormateada = ordenarLista.map((e: any) => ({
            ...e,
            FechaHoraInicio: formatearFechaCustom(e.FechaHoraInicio),
            UltimaActualizacion: formatearFechaCustom(e.UltimaActualizacion),
            FechaAlta: formatearFechaCustom(e.FechaAlta),
            assigned_date: formatearFechaCustom(e.assigned_date),
            reached_state_date: formatearFechaCustom(e.reached_state_date),
            last_update_date: formatearFechaCustom(e.last_update_date),
            dueDate: formatearFechaCustom(e.dueDate),
          }));
          dispatch(setListaTareasTomadasPorUsuario(updatelistaFormateada));
          dispatch(setIsLoading(false));
          dispatch(setStatus("succeeded"));
          dispatch(setSuccess(true));
        }
        dispatch(setMensaje(formatearMensajeBackend(response.data.Mensaje)));
        const mock401 = await import("../../../dataJson/401.json");
        if (mock401.status === 401) {
          dispatch(setStatus("noAutorice"));
          dispatch(
            setMensaje(
              formatearMensajeBackend(
                "Tu sesión ha expirado. Vuelve a iniciar sesión",
              ),
            ),
          );
        }
      }
    }
  };

export const setBackendClearListaTareasTomadasPorUsuario =
  (): Thunk =>
  async (dispatch): Promise<AxiosResponse | AxiosError> => {
    dispatch(setIsLoading(true));
    try {
      let response: AxiosResponse = defaultResp;
      dispatch(setListaTareasTomadasPorUsuario([]));
      dispatch(setIsLoading(false));
      dispatch(setStatus("idle"));
      dispatch(setSuccess(false));
      dispatch(setMensaje(""));
      return response.data;
    } catch (error: any) {
      dispatch(setIsLoading(false));
      dispatch(setStatus("failed"));
      return error as AxiosError;
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const {
  setListaTareasTomadasPorUsuario,
  getListaTareasTomadasPorUsuario,
  setClearListaTareasTomadasPorUsuario,
  setIsLoading,
  setStatus,
  setResult,
  setSuccess,
  setMensaje,
  setError,
} = listaTareasTomadasPorUsuarioSlice.actions;

export default listaTareasTomadasPorUsuarioSlice.reducer;
